import { render, staticRenderFns } from "./cert-autor-verify.vue?vue&type=template&id=1b31d7b0&scoped=true&"
import script from "./cert-autor-verify.vue?vue&type=script&lang=js&"
export * from "./cert-autor-verify.vue?vue&type=script&lang=js&"
import style1 from "./cert-autor-verify.vue?vue&type=style&index=1&id=1b31d7b0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b31d7b0",
  null
  
)

export default component.exports